import React, { useState, useEffect } from "react";
import EyeIcon from "../../Icon-SVG/EyeIcon";
import EyeCloseIcon from "../../Icon-SVG/EyeCloseIcon";
import "./styles.scss";

const TextField = ({ 
  placeholder, 
  labelText, 
  value, 
  required, 
  onChange, 
  name,
  error,
  type,
  autoComplete,
  disabled = false, // Initial disabled state
  enableAfterDelay = 1800 // Default 3s delay (only when initially disabled)
}) => {
  const [hidden, setHidden] = useState(true);
  const [isEnabled, setIsEnabled] = useState(!disabled); // Start enabled unless disabled

  // Browsers ignore autoComplete="off" on password inputs, so "new-password" is
  // the value that actually suppresses autofill. Pass autoComplete explicitly
  // (e.g. "current-password" on the login form) to opt back into it.
  const autoCompleteValue = autoComplete || (type === "password" ? "new-password" : "");

  useEffect(() => {
    if (disabled) { // Only run delay if initially disabled
      const timer = setTimeout(() => {
        setIsEnabled(true);
      }, enableAfterDelay);

      return () => clearTimeout(timer);
    }
  }, [disabled, enableAfterDelay]); // Only re-run if these props change

  const opacityValue = isEnabled ? 1 : 0.6;

  return (
    <div className="label" style={{ 
      color: error ? "#FF4C4C" : "var(--text-color-label)",
      opacity: opacityValue,
      transition: 'opacity 0.3s ease'
    }}>
      {labelText}
      <input
        style={{ 
          border: error ? "1px solid #FF4C4C" : null,
          paddingRight: type === "password" ? "50px": "12px",
          opacity: opacityValue
        }}
        className="field"
        placeholder={placeholder}
        value={value}
        required={required}
        onChange={onChange}
        name={name}
        type={type === "password" && hidden ? "password" : "text"}
        autoComplete={autoCompleteValue}
        disabled={!isEnabled}
      />
      {type === "password" && (
        <div 
          className="password__eye" 
          onClick={() => isEnabled && setHidden(!hidden)}
          style={{ opacity: opacityValue }}
        >
          {hidden ? <EyeIcon /> : <EyeCloseIcon />}
        </div>
      )}
    </div>
  );
};

export default TextField;